import {
  TouchableOpacity,
  View,
  ViewStyle,
  type StyleProp,
  type TextStyle,
  Text,
  StyleSheet,
} from 'react-native'
import { ChevronLeft } from '@/src/assets/icons/ChevronLeft'
import { routerBack } from '@/src/common/utils/routerBack'
import { useMediaQuery } from 'react-responsive'
import type { ComponentProps } from 'react'
import { typography } from '@/src/common/theme'
interface NavigationSectionInterface {
  title: string
  titleStyles?: StyleProp<TextStyle>
  chevronColor?: string
  hideBackButton?: boolean
  titleContainerStyles?: StyleProp<ViewStyle>
  headerContainerStyles?: StyleProp<ViewStyle>
  onBackPress?: ComponentProps<typeof TouchableOpacity>['onPress']
}

export function NavigationSection({
  title,
  titleStyles,
  titleContainerStyles,
  headerContainerStyles,
  chevronColor,
  hideBackButton,
  onBackPress,
}: NavigationSectionInterface) {
  const minWidth1024 = useMediaQuery({ minWidth: 1024 })
  return (
    <View style={[styles.container, titleContainerStyles]}>
      <View style={[styles.header, headerContainerStyles]}>
        {hideBackButton === false || (!hideBackButton && !minWidth1024) ? (
          <TouchableOpacity
            onPress={onBackPress || (() => void routerBack())}
            style={styles.backButton}
            testID="NavigationSection.Press.Back"
          >
            <ChevronLeft size={24} color={chevronColor ?? '#0C5551'} />
          </TouchableOpacity>
        ) : null}

        <Text style={[typography['heading/heading4'], styles.title, titleStyles]} numberOfLines={2}>
          {title}
        </Text>
      </View>
    </View>
  )
}

/** @deprecated just use the named export for {@link NavigationSection} */
export default NavigationSection

const styles = StyleSheet.create({
  container: { alignItems: 'center' },
  header: {
    paddingHorizontal: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 32,
    paddingBottom: 5,
  },
  backButton: { flex: 0, flexBasis: 'auto' },
  title: { flex: 2, textAlign: 'center', color: '#0C5551' },
})
